import { useState } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import returnsServices from '@/returns/services/services'

const useRevertCancelStatus = ({ orderId, fetchData, fetchTimeline, setToastInfo }) => {
  const [showRevertCancelStatusModal, setShowRevertCancelStatusModal] = useState(false)

  const { fetchData: revertCancelStatus, loading: revertingCancelStatus } = useFetch(
    returnsServices.revertCancelStatus,
    {
      doInitialRequest: false,
    }
  )

  const openRevertCancelStatusModal = () => {
    setShowRevertCancelStatusModal(true)
  }

  const closeRevertCancelStatusModal = () => {
    setShowRevertCancelStatusModal(false)
  }

  const handleRevertCancelStatus = async () => {
    try {
      await revertCancelStatus({ orderId })
      setShowRevertCancelStatusModal(false)
      fetchData()
      fetchTimeline()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return {
    showRevertCancelStatusModal,
    revertingCancelStatus,
    handleRevertCancelStatus,
    openRevertCancelStatusModal,
    closeRevertCancelStatusModal,
  }
}

export default useRevertCancelStatus
